import { render } from "./CheckListTab.vue?vue&type=template&id=0d80391c"
import script from "./CheckListTab.vue?vue&type=script&lang=js"
export * from "./CheckListTab.vue?vue&type=script&lang=js"

import "./CheckListTab.vue?vue&type=style&index=0&id=0d80391c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__